<template>
  <QSelect
    v-model="selectedValue"
    :clearable="clearable"
    dense
    :disable="disable"
    emit-value
    filled
    :label="`Select ${product} role`"
    map-options
    :option-label="(item) => item.label"
    option-value="id"
    :options="rolesOptions"
    square
  >
    <template
      v-if="!hideViewButton"
      #after
    >
      <QBtn
        color="primary"
        label="View"
        @click="openRolesPermissionsModal"
      />
    </template>
  </QSelect>
</template>

<script>
import { sortBy } from "lodash-es";
import { storeToRefs } from "pinia";

import { useGlobalAdminStore } from "src/stores/global";

export default {
  name: "RoleDropdown",
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    hideDefault: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    hideViewButton: {
      type: Boolean,
    },
    defaultRoleId: {
      type: [Number, String],
      default: null,
    },
    disable: {
      type: Boolean,
    },
    product: {
      type: String,
      default: "traditional",
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const globalAdminStore = useGlobalAdminStore();
    const { roles } = storeToRefs(globalAdminStore);

    return { roles };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    defaultRoleName() {
      const defaultRole =
        this.defaultRoleId &&
        this.roles.find(({ id }) => Number(id) === Number(this.defaultRoleId));

      return defaultRole ? `default (${defaultRole.name})` : "default";
    },
    rolesOptions() {
      const roles = [];

      if (!this.hideDefault) {
        roles.push({
          id: null,
          label: this.defaultRoleName,
        });
      }

      return roles.concat(
        this.sortedRoles.map((role) => ({
          ...role,
          id: Number(role.id),
          label: `${role.position} - ${role.name}`,
        }))
      );
    },
    filteredRoles() {
      return this.roles.filter((role) => role.product === this.product);
    },
    sortedRoles() {
      return sortBy(this.filteredRoles, (role) => role.position);
    },
  },
  methods: {
    openRolesPermissionsModal() {
      this.$modals.open("RolesPermissionsModal", {
        props: {
          product: this.product,
        },
      });
    },
  },
};
</script>
